// Display contract only. Payment/pauses/course-switch decisions come from the API.
export function accountNoticeState(payload) {
  if (!payload || payload.success !== true ||
      typeof payload.payment_due !== "boolean" ||
      typeof payload.profile_review_required !== "boolean" ||
      typeof payload.subscription_required !== "boolean" ||
      typeof payload.subscription_valid !== "boolean" ||
      typeof payload.subscription_review_required !== "boolean" ||
      !Array.isArray(payload.openPayments) || !Array.isArray(payload.profileReviews)) {
    throw new Error("Account status is unavailable");
  }
  const openPayments = payload.openPayments.filter((item) =>
    item && typeof item.key === "string" && typeof item.label === "string" &&
    item.label.trim() !== "" && item.status === "open"
  );
  const profileReviews = payload.profileReviews.filter((item) =>
    item && typeof item.key === "string" && typeof item.title === "string" &&
    item.title.trim() !== ""
  );
  if (payload.payment_due !== (openPayments.length > 0) ||
      payload.profile_review_required !== (profileReviews.length > 0)) {
    throw new Error("Account status is incomplete");
  }
  return {
    loaded: true,
    paymentDue: payload.payment_due,
    profileReviewRequired: payload.profile_review_required,
    subscriptionRequired: payload.subscription_required,
    subscriptionValid: payload.subscription_valid,
    subscriptionReviewRequired: payload.subscription_review_required,
    openPayments,
    profileReviews,
    unavailable: false,
  };
}

export function unavailableAccountNotice(previous) {
  // An unavailable refresh must never clear a previously confirmed open payment.
  const prior = previous && Array.isArray(previous.openPayments) ? previous : null;
  return {
    loaded: false,
    paymentDue: prior ? prior.paymentDue : null,
    profileReviewRequired: true,
    openPayments: prior ? prior.openPayments : [],
    profileReviews: prior ? prior.profileReviews : [],
    unavailable: true,
  };
}

export function accountNoticeTone(status) {
  if (!status) return "neutral";
  if (status.paymentDue === true) return "red";
  if (status.unavailable === true || status.loaded !== true || status.profileReviewRequired === true || status.subscriptionReviewRequired === true) return "yellow";
  if (status.subscriptionRequired === true && status.subscriptionValid === false) return "red";
  return "green";
}
